import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PictureService } from '../../../core/services/picture.service';
import { EventService } from '../../../core/services/event.service';

@Component({
    selector: 'picture-modal',
    templateUrl: './picture-modal.html',
    styleUrls: ['./picture-modal.scss'],
    standalone: false
})

export class PictureModalComponent implements OnInit {

  public pictures;
  public _albums = [];

  constructor(public dialogRef: MatDialogRef<PictureModalComponent>, private pictureService: PictureService,
              public eventService: EventService) {
  }

  ngOnInit() {
    this.pictureService.getPictures().then(res => {
      this.pictures = res;
      this._albums = [];
      for (let i = 0; i < this.pictures.length; i++) {
        const src = this.pictures[ i ].name;
        const caption = '';
        const thumb = '';
        const album = {
          src: src ,
          caption: caption ,
          thumb: thumb
        };

        this._albums.push(album);
      }
    });
  }

  useImage(image) {
    this.dialogRef.close({src: image});
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  closeDialog() {
    this.dialogRef.close('Pizza!');
  }
}
